/* בול פרקט, דף מוצר (שיחה 05): הוספה לסל בלי לעזוב את הדף.
   שולח לשופיפיי, מעדכן את הסל הצדדי של התבנית (Horizon, דרך CartLinesUpdateEvent של @shopify/events)
   ואת מספר הפריטים באיקון, ופותח את הסל הצדדי כשמבקשים.
   שימוש: bpCartAdd({ form: formElement }) או bpCartAdd({ id: 123, quantity: 1 }), מחזיר Promise עם הסל. */
(function () {
  if (window.bpCartAdd) return;
  function sectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function (c) { if (c.dataset.sectionId) ids.push(c.dataset.sectionId); });
    return ids.join(',');
  }
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  window.bpCartAdd = function (opt) {
    opt = opt || {};
    var fd, id, qty, el = opt.form || opt.el || document;
    if (opt.form) {
      fd = new FormData(opt.form);
      id = fd.get('id'); qty = Number(fd.get('quantity')) || 1;
    } else {
      fd = new FormData();
      id = opt.id; qty = opt.quantity || 1;
      fd.append('id', id); fd.append('quantity', qty);
    }
    var secs = sectionIds();
    if (secs) fd.append('sections', secs);
    var addResp;
    return fetch(root() + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (j) { addResp = j; return fetch(root() + 'cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        document.querySelectorAll('.cart-bubble__text-count, [ref="cartBubbleCount"]').forEach(function (x) { x.textContent = cart.item_count; });
        document.querySelectorAll('.cart-bubble, .cart-bubble__text-count').forEach(function (x) { x.classList.remove('visually-hidden', 'hidden'); });
        var detail = { source: 'bppd', sourceId: 'bppd', itemCount: qty, productId: opt.productId, sections: (addResp && addResp.sections) || {} };
        import('@shopify/events').then(function (ev) {
          var E = ev.CartLinesUpdateEvent;
          var d = E.createPromise();
          el.dispatchEvent(new E({ action: 'add', context: 'product', lines: [{ merchandiseId: String(id), quantity: qty }], promise: d.promise }));
          d.resolve({ cart: E.createCartFromAjaxResponse(cart), detail: detail });
        }).catch(function () {});
        if (opt.openDrawer) {
          var dr = document.getElementById('cart-drawer');
          if (dr && typeof dr.open === 'function') setTimeout(function () { try { dr.open(); } catch (x) {} }, 300);
        }
        return cart;
      });
  };
})();
